// Inquiry context release: 2026-07-18
(function () {
  'use strict';

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  var menuButton = document.querySelector('[data-menu-button]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function closeMenu() {
    if (!menuButton || !mobileNav) return;
    mobileNav.hidden = true;
    menuButton.setAttribute('aria-expanded', 'false');
  }

  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', function () {
      var opening = mobileNav.hidden;
      mobileNav.hidden = !opening;
      menuButton.setAttribute('aria-expanded', opening ? 'true' : 'false');
    });
    all('a', mobileNav).forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
  }

  all('[data-language-selector]').forEach(function (selector) {
    selector.addEventListener('change', function () {
      if (selector.form) selector.form.submit();
    });
  });

  all('.work-order-form [required]').forEach(function (field, index) {
    var errorId = (field.id || 'InquiryField' + index) + '-error';

    function errorContainer() {
      return field.closest('.field-group') || field.closest('.consent-field');
    }

    function showFieldError() {
      var container = errorContainer();
      if (!container) return;
      var message = container.parentElement.querySelector('#' + errorId);
      if (!message) {
        message = document.createElement('small');
        message.id = errorId;
        message.className = 'field-error-message';
        container.insertAdjacentElement('afterend', message);
      }
      message.textContent = field.validationMessage;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', errorId);
    }

    function clearFieldError() {
      if (!field.validity.valid) return;
      var message = document.getElementById(errorId);
      if (message) message.remove();
      field.removeAttribute('aria-invalid');
      field.removeAttribute('aria-describedby');
    }

    field.addEventListener('invalid', showFieldError);
    field.addEventListener('input', clearFieldError);
    field.addEventListener('change', clearFieldError);
  });

  function clamp(value, minimum, maximum) {
    return Math.max(minimum, Math.min(maximum, value));
  }

  function easeInOut(value) {
    return value < 0.5
      ? 4 * value * value * value
      : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function initAssembly(root) {
    if (!root || root.dataset.assemblyInitialized === 'true') return;

    var sticky = root.querySelector('[data-assembly-sticky]');
    var drawing = root.querySelector('.drawing-sheet');
    var progress = root.querySelector('[data-assembly-progress]');
    var phase = root.querySelector('[data-assembly-phase]');
    var instruction = root.querySelector('[data-assembly-instruction]');
    var replay = root.querySelector('[data-assembly-replay]');
    var parts = all('[data-assembly-part]', root).map(function (element) {
      var range = (element.dataset.assemblyRange || '0,1').split(',');
      return {
        element: element,
        kind: element.dataset.assemblyPart,
        from: parseFloat(range[0]),
        to: parseFloat(range[1])
      };
    });

    if (!sticky || !drawing || !parts.length) return;

    root.dataset.assemblyInitialized = 'true';

    var enabled = root.dataset.assemblyEnabled !== 'false';
    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    var desktopQuery = window.matchMedia('(min-width: 961px) and (min-height: 720px)');
    var stickySupported = !!(window.CSS && CSS.supports && CSS.supports('position', 'sticky'));
    var phases = [
      [0, root.dataset.assemblyPhaseStructure],
      [0.25, root.dataset.assemblyPhasePowertrain],
      [0.55, root.dataset.assemblyPhaseWorkingParts],
      [0.75, root.dataset.assemblyPhaseDocumentation],
      [0.93, root.dataset.assemblyPhaseComplete]
    ];
    var mode = '';
    var playing = false;
    var autoPlayed = false;
    var playRequest = 0;
    var scrubRequest = 0;
    var configureRequest = 0;
    var playToken = 0;
    var observer = null;

    function setProgress(value) {
      var amount = clamp(value, 0, 1);

      parts.forEach(function (part) {
        var duration = part.to - part.from;
        var local = duration > 0 ? clamp((amount - part.from) / duration, 0, 1) : (amount >= part.to ? 1 : 0);
        if (part.kind === 'draw') {
          part.element.style.strokeDashoffset = String(1 - local);
        } else {
          part.element.style.opacity = String(local);
        }
      });

      if (progress) progress.textContent = Math.round(amount * 100) + '%';
      if (phase) {
        for (var index = phases.length - 1; index >= 0; index -= 1) {
          if (amount >= phases[index][0]) {
            phase.textContent = phases[index][1];
            break;
          }
        }
      }

      root.dataset.assemblyProgress = amount.toFixed(3);
    }

    function setInstruction(text) {
      if (instruction) instruction.textContent = text;
    }

    function updateHeaderOffset() {
      var header = document.querySelector('.site-header');
      var height = header ? header.offsetHeight : 65;
      root.style.setProperty('--hero-header-offset', height + 'px');
    }

    function stopPlayback() {
      playToken += 1;
      playing = false;
      if (playRequest) cancelAnimationFrame(playRequest);
      playRequest = 0;
    }

    function playAssembly() {
      if (reduceQuery.matches || mode === 'static') {
        setProgress(1);
        return;
      }

      stopPlayback();
      playing = true;
      var token = playToken;
      var startedAt = 0;
      setProgress(0);

      function step(timestamp) {
        if (token !== playToken) return;
        if (!startedAt) startedAt = timestamp;
        var elapsed = Math.min((timestamp - startedAt) / 2200, 1);
        setProgress(easeInOut(elapsed));
        if (elapsed < 1) {
          playRequest = requestAnimationFrame(step);
        } else {
          playing = false;
          playRequest = 0;
        }
      }

      playRequest = requestAnimationFrame(step);
    }

    function currentScrollProgress() {
      var header = document.querySelector('.site-header');
      var headerHeight = header ? header.offsetHeight : 65;
      var rect = root.getBoundingClientRect();
      var denominator = Math.max(root.offsetHeight - sticky.offsetHeight, 1);
      return clamp((headerHeight - rect.top) / denominator, 0, 1);
    }

    function scheduleScrub() {
      if (mode !== 'scroll' || playing || scrubRequest) return;
      scrubRequest = requestAnimationFrame(function () {
        scrubRequest = 0;
        setProgress(currentScrollProgress());
      });
    }

    function drawingIsVisible() {
      var rect = drawing.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    }

    function startAutoIfReady() {
      if (mode !== 'auto' || autoPlayed || !drawingIsVisible()) return;
      autoPlayed = true;
      playAssembly();
    }

    function targetMode() {
      if (!enabled || reduceQuery.matches) return 'static';
      return desktopQuery.matches && stickySupported ? 'scroll' : 'auto';
    }

    function configureMode() {
      configureRequest = 0;
      updateHeaderOffset();
      var nextMode = targetMode();

      if (nextMode === mode) {
        if (mode === 'scroll') scheduleScrub();
        if (mode === 'auto') startAutoIfReady();
        return;
      }

      stopPlayback();
      mode = nextMode;
      autoPlayed = false;
      root.classList.add('assembly-ready');
      root.classList.toggle('is-scroll-mode', mode === 'scroll');
      root.classList.toggle('is-auto-mode', mode === 'auto');
      root.classList.toggle('is-static-mode', mode === 'static');
      root.dataset.assemblyMode = mode;

      if (mode === 'static') {
        setInstruction(root.dataset.assemblyStaticInstruction);
        setProgress(1);
      } else if (mode === 'scroll') {
        setInstruction(root.dataset.assemblyScrollInstruction);
        requestAnimationFrame(scheduleScrub);
      } else {
        setInstruction(root.dataset.assemblyAutoInstruction);
        setProgress(0);
        requestAnimationFrame(startAutoIfReady);
      }
    }

    function scheduleConfigure() {
      if (configureRequest) return;
      configureRequest = requestAnimationFrame(configureMode);
    }

    function handleScroll() {
      if (mode === 'scroll') scheduleScrub();
      if (mode === 'auto') startAutoIfReady();
    }

    function listenToQuery(query) {
      if (query.addEventListener) query.addEventListener('change', scheduleConfigure);
      else if (query.addListener) query.addListener(scheduleConfigure);
    }

    function stopListeningToQuery(query) {
      if (query.removeEventListener) query.removeEventListener('change', scheduleConfigure);
      else if (query.removeListener) query.removeListener(scheduleConfigure);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startAutoIfReady();
        });
      }, { threshold: 0.25 });
      observer.observe(drawing);
    }

    if (replay) replay.addEventListener('click', playAssembly);
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', scheduleConfigure, { passive: true });
    listenToQuery(reduceQuery);
    listenToQuery(desktopQuery);
    configureMode();

    root._assemblyCleanup = function () {
      stopPlayback();
      if (scrubRequest) cancelAnimationFrame(scrubRequest);
      if (configureRequest) cancelAnimationFrame(configureRequest);
      if (observer) observer.disconnect();
      if (replay) replay.removeEventListener('click', playAssembly);
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', scheduleConfigure);
      stopListeningToQuery(reduceQuery);
      stopListeningToQuery(desktopQuery);
      root.removeAttribute('data-assembly-initialized');
    };
  }

  all('[data-assembly-hero]').forEach(initAssembly);

  document.addEventListener('shopify:section:load', function (event) {
    all('[data-assembly-hero]', event.target).forEach(initAssembly);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    all('[data-assembly-hero]', event.target).forEach(function (root) {
      if (root._assemblyCleanup) root._assemblyCleanup();
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenu();
  });

  var selectorRoot = document.querySelector('[data-product-selector]');
  var inquiryModel = document.querySelector('[data-inquiry-model]');
  var inquiryHandle = document.querySelector('[data-inquiry-handle]');
  var inquiryVariant = document.querySelector('[data-inquiry-variant]');
  var inquiryVariantId = document.querySelector('[data-inquiry-variant-id]');
  var inquirySource = document.querySelector('[data-inquiry-source]');

  var attributionStoragePrefix = 'aonxin_attribution_';
  var attributionParameters = new URLSearchParams(window.location.search);

  function readSessionValue(key) {
    try { return window.sessionStorage.getItem(attributionStoragePrefix + key) || ''; }
    catch (error) { return ''; }
  }

  function writeSessionValue(key, value) {
    if (!value || readSessionValue(key)) return;
    try { window.sessionStorage.setItem(attributionStoragePrefix + key, value); }
    catch (error) { /* Attribution remains available for the current page. */ }
  }

  function createLeadId() {
    var now = new Date();
    var date = [now.getUTCFullYear(), String(now.getUTCMonth() + 1).padStart(2, '0'), String(now.getUTCDate()).padStart(2, '0')].join('');
    var random = '';
    if (window.crypto && window.crypto.getRandomValues) {
      var values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      random = values[0].toString(36).slice(0, 6).toUpperCase();
    } else {
      random = Math.random().toString(36).slice(2, 8).toUpperCase();
    }
    return 'AX-' + date + '-' + random;
  }

  writeSessionValue('lead_id', createLeadId());
  writeSessionValue('landing_page', window.location.href);
  writeSessionValue('referrer', document.referrer);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
    writeSessionValue(key, attributionParameters.get(key));
  });

  function setAttributionField(selector, value) {
    var field = document.querySelector(selector);
    if (field && value && !field.value) field.value = value;
  }

  setAttributionField('[data-attribution-lead-id]', readSessionValue('lead_id') || createLeadId());
  setAttributionField('[data-attribution-submitted-page]', window.location.href);
  setAttributionField('[data-attribution-landing-page]', readSessionValue('landing_page') || window.location.href);
  setAttributionField('[data-attribution-referrer]', readSessionValue('referrer') || document.referrer || 'Direct / unavailable');
  setAttributionField('[data-attribution-utm-source]', readSessionValue('utm_source') || attributionParameters.get('utm_source'));
  setAttributionField('[data-attribution-utm-medium]', readSessionValue('utm_medium') || attributionParameters.get('utm_medium'));
  setAttributionField('[data-attribution-utm-campaign]', readSessionValue('utm_campaign') || attributionParameters.get('utm_campaign'));
  setAttributionField('[data-attribution-utm-term]', readSessionValue('utm_term') || attributionParameters.get('utm_term'));
  setAttributionField('[data-attribution-utm-content]', readSessionValue('utm_content') || attributionParameters.get('utm_content'));
  setAttributionField('[data-attribution-language]', document.documentElement.lang || 'en');

  if (inquiryModel && !inquiryModel.value && inquiryModel.dataset.inquiryDefaultModel) {
    inquiryModel.value = inquiryModel.dataset.inquiryDefaultModel;
  }

  function machineLabel(card) {
    if (!card) return '';
    var code = card.dataset.code || '';
    var title = card.dataset.title || '';
    return (code ? code + ' — ' : '') + title;
  }

  function setInquiryContext(context) {
    context = context || {};
    if (inquiryModel && context.model !== undefined) inquiryModel.value = context.model;
    if (inquiryHandle && context.handle !== undefined) inquiryHandle.value = context.handle;
    if (inquiryVariant && context.variant !== undefined) inquiryVariant.value = context.variant;
    if (inquiryVariantId && context.variantId !== undefined) inquiryVariantId.value = context.variantId;
    if (inquirySource && context.source !== undefined) inquirySource.value = context.source;
  }

  function setInquiryModel(card) {
    if (!card) return;
    setInquiryContext({
      model: machineLabel(card),
      handle: card.dataset.handle || '',
      variant: '',
      variantId: '',
      source: window.location.href
    });
  }

  function setText(root, selector, value, fallback) {
    var element = root.querySelector(selector);
    if (element) element.textContent = value || fallback;
  }

  function selectMachine(card, updateInquiry) {
    if (!selectorRoot || !card) return;
    all('[data-machine-card]', selectorRoot).forEach(function (item) {
      var active = item === card;
      item.classList.toggle('is-active', active);
      var selectButton = item.querySelector('[data-machine-select]');
      if (selectButton) selectButton.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    var code = card.dataset.code || '';
    var title = card.dataset.title || '';
    setText(selectorRoot, '[data-product-code]', code, selectorRoot.dataset.modelFallback);
    setText(selectorRoot, '[data-product-width]', card.dataset.width, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-depth]', card.dataset.depth, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-hp]', card.dataset.hp, selectorRoot.dataset.engineeringReview);
    setText(selectorRoot, '[data-product-linkage]', card.dataset.linkage, selectorRoot.dataset.modelDependent);
    setText(selectorRoot, '[data-product-weight]', card.dataset.weight, selectorRoot.dataset.confirmWithQuote);
    setText(selectorRoot, '[data-product-wear]', card.dataset.wear, selectorRoot.dataset.availableWithQuote);

    var details = selectorRoot.querySelector('[data-product-link]');
    if (details) {
      details.href = card.dataset.url || '#inquiry';
      details.textContent = card.dataset.url ? selectorRoot.dataset.fullDetails : selectorRoot.dataset.requestDatasheet;
    }
    var quote = selectorRoot.querySelector('[data-product-quote]');
    if (quote) quote.textContent = selectorRoot.dataset.requestQuote + ' — ' + (code || title);
    if (updateInquiry !== false) setInquiryModel(card);
  }

  if (selectorRoot) {
    all('[data-machine-card]', selectorRoot).forEach(function (card) {
      var selectButton = card.querySelector('[data-machine-select]');
      if (selectButton) selectButton.addEventListener('click', function () { selectMachine(card); });
    });
    var firstCard = selectorRoot.querySelector('[data-machine-card]');
    if (firstCard) selectMachine(firstCard, false);

    all('[data-machine-filter]', selectorRoot).forEach(function (filterButton) {
      filterButton.addEventListener('click', function () {
        var category = filterButton.dataset.machineFilter || 'all';
        all('[data-machine-filter]', selectorRoot).forEach(function (button) {
          var active = button === filterButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        var visibleCards = [];
        all('[data-machine-card]', selectorRoot).forEach(function (card) {
          var visible = category === 'all' || card.dataset.machineCategory === category;
          card.hidden = !visible;
          if (visible) visibleCards.push(card);
        });

        var activeCard = selectorRoot.querySelector('[data-machine-card].is-active:not([hidden])');
        if (!activeCard && visibleCards.length) selectMachine(visibleCards[0]);
      });
    });

    var selectorQuote = selectorRoot.querySelector('[data-product-quote]');
    if (selectorQuote) {
      selectorQuote.addEventListener('click', function () {
        setInquiryModel(selectorRoot.querySelector('[data-machine-card].is-active'));
      });
    }
  }

  var inquiryParameters = new URLSearchParams(window.location.search);
  var inquiryModelFromUrl = inquiryParameters.get('inquiry_model');
  var inquiryHandleFromUrl = inquiryParameters.get('inquiry_handle');
  var inquiryVariantFromUrl = inquiryParameters.get('inquiry_variant');
  var inquiryVariantIdFromUrl = inquiryParameters.get('inquiry_variant_id');
  var inquirySourceFromUrl = inquiryParameters.get('inquiry_source');
  if (inquiryModelFromUrl || inquiryHandleFromUrl || inquiryVariantFromUrl || inquiryVariantIdFromUrl || inquirySourceFromUrl) {
    setInquiryContext({
      model: inquiryModelFromUrl || '',
      handle: inquiryHandleFromUrl || '',
      variant: inquiryVariantFromUrl || '',
      variantId: inquiryVariantIdFromUrl || '',
      source: inquirySourceFromUrl || window.location.href
    });
  } else if (inquirySource && !inquirySource.value) {
    inquirySource.value = window.location.href;
  }

  function productQuoteContext(quote) {
    var selectId = quote.dataset.inquiryVariantSelect;
    var select = selectId ? document.getElementById(selectId) : null;
    var option = select && select.options[select.selectedIndex];
    return {
      model: quote.dataset.inquiryModel || '',
      handle: quote.dataset.inquiryHandle || '',
      variant: option ? option.textContent.trim() : (quote.dataset.inquiryDefaultVariant || ''),
      variantId: option ? option.value : (quote.dataset.inquiryDefaultVariantId || ''),
      source: quote.dataset.inquirySource || window.location.href
    };
  }

  function syncProductQuote(quote) {
    var context = productQuoteContext(quote);
    var url = new URL(quote.getAttribute('href') || window.location.href, window.location.origin);
    url.searchParams.set('inquiry_model', context.model);
    url.searchParams.set('inquiry_handle', context.handle);
    url.searchParams.set('inquiry_variant', context.variant);
    url.searchParams.set('inquiry_variant_id', context.variantId);
    url.searchParams.set('inquiry_source', context.source);
    url.hash = 'inquiry';
    quote.href = url.pathname + url.search + url.hash;
  }

  all('[data-product-quote-button]').forEach(function (quote) {
    syncProductQuote(quote);
    var selectId = quote.dataset.inquiryVariantSelect;
    var select = selectId ? document.getElementById(selectId) : null;
    if (select) select.addEventListener('change', function () { syncProductQuote(quote); });
    quote.addEventListener('click', function () { syncProductQuote(quote); });
  });

  var fitRoot = document.querySelector('[data-project-fit]');
  if (fitRoot) {
    var power = fitRoot.querySelector('[data-fit-power]');
    var depth = fitRoot.querySelector('[data-fit-depth]');
    var output = fitRoot.querySelector('[data-fit-depth-output]');
    var addRequirement = fitRoot.querySelector('[data-fit-inquiry]');
    var inquiryPower = document.querySelector('[data-inquiry-power]');
    var inquiryRequirement = document.querySelector('[data-inquiry-requirement]');

    function updateDepth() {
      if (depth && output) output.textContent = depth.value;
    }
    if (depth) depth.addEventListener('input', updateDepth);
    updateDepth();

    if (addRequirement) {
      addRequirement.addEventListener('click', function () {
        if (inquiryPower && power) inquiryPower.value = power.value;
        if (inquiryRequirement && depth) {
          var note = (fitRoot.dataset.targetDepthNote || 'Target working depth: {depth} mm.').replace('{depth}', depth.value);
          if (inquiryRequirement.value.indexOf(note) === -1) {
            inquiryRequirement.value = inquiryRequirement.value ? inquiryRequirement.value + '\n' + note : note;
          }
        }
      });
    }
  }
})();
